import { InformationBlockCombinedProps } from './types';

const usePresenter = (props: InformationBlockCombinedProps): InformationBlockCombinedProps => {
  return props;
};

export default usePresenter;
